export default __webpack_public_path__ + "static/media/healthcare4.86ce0ba2.png";